// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_COLUMN_HEADINGS = {
  price: 'Price',
  size: 'Size',
  unitDetails: 'Unit Details',
};

export const DEFAULT_PRICE_DISPLAY = { displayCents: false, showCents: false };
